/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */
import produce from 'immer';

import { IAppActionTypes } from './appActions';
import {
    INIT_APP_FAIL,
    INIT_APP_START,
    INIT_APP_SUCCESS,
    initialAppState,
    LOAD_APP_CONFIG_FAILURE,
    LOAD_APP_CONFIG_SUCCESS,
    SET_APP_ERROR,
    SET_APP_ERROR_CODE,
    SET_INIT_APP_ERROR,
} from './appConstants';
import { IAppReducerState } from './appTypes';

/**
 * Root component reduser
 * @param {IAppReducerState} state
 * @param action
 * @returns {Produced<IAppReducerState, void>}
 */
const appReducer = (state: IAppReducerState = initialAppState, action: IAppActionTypes) =>
    produce(state, (draft) => {
        switch (action.type) {
            case INIT_APP_START:
                draft.isLoaded = false;
                draft.isLoading = true;
                break;
            case INIT_APP_SUCCESS:
                draft.isLoaded = true;
                break;
            case INIT_APP_FAIL:
                draft.errorMessage = action.payload;
                draft.isLoaded = true;
                break;
            case LOAD_APP_CONFIG_SUCCESS:
                draft.config = action.payload;
                draft.isLoading = false;
                break;
            case LOAD_APP_CONFIG_FAILURE:
                draft.errorMessage = action.payload;
                draft.isLoading = false;
                break;

            // APP SET ERROR
            case SET_APP_ERROR:
                draft.hasError = action.payload.hasError;
                break;
            case SET_INIT_APP_ERROR:
                draft.hasInitError = action.payload.hasInitError;
                draft.code = action.payload.code || '';
                break;
            case SET_APP_ERROR_CODE:
                draft.code = action.payload.code;
                break;

            default:
                break;
        }
    });

export default appReducer;
